import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

type DraftRecoveryDialogProps = {
  open: boolean;
  updatedAt?: string | null;
  title?: string;
  onRestore: () => void;
  onDiscard: () => void;
};

export function DraftRecoveryDialog({
  open,
  updatedAt,
  title = 'Unsaved Draft Found',
  onRestore,
  onDiscard,
}: DraftRecoveryDialogProps) {
  return (
    <Dialog open={open} fullWidth maxWidth="xs">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={1.5}>
          <Typography>We found unsaved changes from a previous session.</Typography>
          <Typography variant="body2" color="text.secondary">
            Last updated: {updatedAt ? new Date(updatedAt).toLocaleString() : 'Unknown'}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ flexWrap: 'wrap' }}>
        <Button color="error" onClick={onDiscard}>Discard Draft</Button>
        <Button variant="contained" onClick={onRestore}>Restore Draft</Button>
      </DialogActions>
    </Dialog>
  );
}
